/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdLinkProps } from './type';

export const linkDefaultProps: TdLinkProps = { disabled: undefined, size: 'medium', theme: 'default' };
